import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { cloneDeep, first, filter } from 'lodash';
import { connect } from 'react-redux';
import { Button, Dropdown, MenuItem } from 'react-bootstrap';
import { fetchAllFeedbackRequestAutomations } from '../../SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import ConfirmButton from '../../../../components/confirm-button';
import styles from './styles.css';

class CopyQueryControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      loading: false,
      error: null,
      automations: [],
      open: false,
    };
    this.loadAutomations = this.loadAutomations.bind(this);
    this.handleDropdownToggle = this.handleDropdownToggle.bind(this);
    this.applyQuery = this.applyQuery.bind(this);
  }


  applyQuery(searchQuery) {
    this.props.onDone(cloneDeep(searchQuery));
  }

  loadAutomations() {
    if (!this.state.loaded && !this.state.loading) {
      this.setState({ loading: true }, () => {
        this.props.dispatch(fetchAllFeedbackRequestAutomations())
          .then(
            ({ settings }) => {
              const automations = filter(settings, { source: this.props.isAccount ? 'account' : 'opportunity' });
              this.setState({
                loading: false,
                loaded: true,
                automations,
                open: true,
              }, () => {
                // load and apply
                if (this.state.automations.length === 1) {
                  this.applyQuery(this.state.automations[0].search_query);
                }
              });
            },
            (error) => {
              // error
              this.setState({ loaded: false, loadding: false, error });
            },
          );
      });
    }
  }


  handleDropdownToggle(open) {
    this.setState({ open });
  }

  
  renderMultiple() {
    const { className, disabled, shouldConfirm } = this.props;
    const { open, automations } = this.state;
    if (automations.length === 1) {
      return this.renderSingle(automations[0].search_query);
    }
    return (
      <Dropdown
        disabled={disabled}
        id="dropdown-ranges"
        onToggle={this.handleDropdownToggle}
        open={open}
        dropup
      >
        <Dropdown.Toggle className={className} disabled={disabled}>
          {this.renderLabel()}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem header>Available automations:</MenuItem>
          {automations.map((automation) => {
            const inner = (
              <><Fa name="star" className={automation.is_system ? 'text-warning' : 'invisible'} /> {automation.name}</>
            );

            const handler = () => {
              this.applyQuery(automation.search_query);
              this.setState({ open: false });
            };

            if (shouldConfirm) {
              return (
                <li key={automation._id}>
                  <ConfirmButton
                    disabled={disabled}
                    className={styles.confirmBtn}
                    confirmMessage="Are you sure?"
                    confirmStyle="link"
                    onConfirm={handler}
                  >
                    {inner}
                  </ConfirmButton>
                </li>
              );
            }
            return (
              <MenuItem
                key={automation._id}
                disabled={disabled}
                onSelect={handler}
              >
                {inner}
              </MenuItem>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }


  renderLabel() {
    const { loading } = this.state;
    return (
      <span>
        <Fa name={loading ? 'spinner' : 'copy'} spin={loading} /> Copy From Automation Triggers
      </span>
    );
  }


  renderSingle(fromQuery) {
    const { className, disabled, shouldConfirm } = this.props;
    let comp = null;

    const handler = () => {
      this.applyQuery(fromQuery);
    };

    if (shouldConfirm) {
      comp = (
        <div className={className}>
          <ConfirmButton
            disabled={disabled}
            confirmMessage="Are you sure?"
            confirmStyle="link"
            onConfirm={handler}
          >
            {this.renderLabel()}
          </ConfirmButton>
        </div>
      );
    } else {
      comp = (
        <Button
          disabled={disabled}
          onClick={handler}
          className={className}
          bsStyle="link"
        >
          {this.renderLabel()}
        </Button>
      );
    }
    return comp;
  }



  render() {
    const { className, disabled, shouldConfirm } = this.props;
    const { loading, loaded } = this.state;
    const isLocalOnly = this.props.fromQuery !== null && this.props.fromQuery !== undefined;
    if (isLocalOnly) {
      return this.renderSingle(this.props.fromQuery); // local copy only
    }

    if (!loaded) {
      return (
        <Button disabled={(loading || disabled)} onClick={this.loadAutomations} className={className} bsStyle="link">
          {this.renderLabel()}
        </Button>
      );
    }

    return this.renderMultiple();
   
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

CopyQueryControl.propTypes = {
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  shouldConfirm: PropTypes.bool,
  fromQuery: PropTypes.shape({}),
  onDone: PropTypes.func,
  isAccount: PropTypes.bool,
  currentId: PropTypes.string,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};
CopyQueryControl.defaultProps = {
  className: 'pull-right',
  disabled: false,
  fromQuery: null,
  shouldConfirm: false,
  isAccount: false,
  currentId: null,
  onDone: () => {},
};

export default connect(mapStateToProps)(CopyQueryControl);
